module.exports = __webpack_public_path__ + "img/red_cabinet.51354081.svg";